import type { GeneratedItem, ItemId } from '@/types/domain';

export function reconstructGrid(item: GeneratedItem): (ItemId | null)[] {
  const grid: (ItemId | null)[] = Array(9).fill(null);
  item.ingredientIds.forEach((id, i) => {
    const pos = item.ingredientPositions[i];
    if (pos === null) {
      const idx = grid.findIndex((c) => c === null);
      if (idx >= 0) grid[idx] = id;
    } else {
      grid[pos] = id;
    }
  });
  return grid;
}
